"use client";

import { AIInsightCategoryTab } from "@components/AIInsight/AIInsightCategoryTab";
import { DeviceType } from "utils/src/uaDevicesParse/ua-device-parser";
import { MainTabHeader } from "@components/Header/MainTabHeader";
import type { NewsThemeGroup } from "@utils/newsRanking";
import { useParams } from "next/navigation";

export function NewsTopTabs({ groups }: { groups: NewsThemeGroup[] }) {
  const { device } = useParams<{ device?: DeviceType }>();
  const isPc = device === "desktop";
  return (
    <>
      {isPc ? (
        <AIInsightCategoryTab groups={groups} className="px-4 md:px-15 pt-2" />
      ) : (
        <div className="sticky top-[0px] z-20 w-full flex-col flex">
          <MainTabHeader
            trackingModuleName="edgen_news_header_upgrade"
            variant="plan"
          />
          <AIInsightCategoryTab className="px-4" groups={groups} />
        </div>
      )}
    </>
  );
}
